<img class="safety-logo" src="../../assets/images/safety_2_logo_white.svg"/>
@if (openInfoEquipment) {
  <mat-card appearance="outlined">
    <div>{{ openInfoEquipment.categoryName }}</div>
    @if (openInfoEquipment.childCategoryName) {
      <div>{{ openInfoEquipment.childCategoryName }}</div>
    }
    @if (openInfoEquipment.location) {
      <div>{{ openInfoEquipment.location }}</div>
    }
    @if (openInfoEquipment.manufacturer) {
      <div>{{ openInfoEquipment.manufacturer }}</div>
    }
    @if (openInfoEquipment.equipmentName) {
      <div>{{ openInfoEquipment.equipmentName }}</div>
    }
    @if (openInfoEquipment.serialNumber) {
      <div>{{ 'serialNumber' | translate }}: {{ openInfoEquipment.serialNumber }}</div>
    }
    @if (openInfoEquipment.internalNumber) {
      <div>{{ 'internalNumber' | translate }}: {{ openInfoEquipment.internalNumber }}</div>
    }
    @if (openInfoEquipment.inventoryNumber) {
      <div>{{ 'inventoryNumber' | translate }}: {{ openInfoEquipment.inventoryNumber }}</div>
    }
    <mat-card-content style="margin-top: 16px;">
      @for (item of openInfoEquipment.openInfoExams; track item; let last = $last) {
        <div>
          <div>{{ ('exam' | translate) + ': '}}</div>
          <div style="margin-bottom: 4px">{{ item.examTypeName }}</div>
          <div>{{ ('nextExamDate' | translate) + ': '}}</div>
          <div>{{ (item.nextExamDate ? (item.nextExamDate | date) : ('noExamDate' | translate)) }}</div>
          <div>{{ ('latestExamDate' | translate) + ': '}}</div>
          <div>{{ (item.latestExamDate ? (item.latestExamDate | date) : ('noExamDate' | translate)) }}</div>
          @if (!last) {
            <mat-divider style="margin-top:16px; margin-bottom: 16px"></mat-divider>
          }
        </div>
      }
      @if (openInfoEquipment.openInfoExams.length === 0) {
        <div>
          <p>{{ 'noExamInfo' | translate }}</p>
        </div>
      }
    </mat-card-content>
  </mat-card>
}
@if (!openInfoEquipment) {
  <mat-card appearance="outlined">
    <p>{{ 'noEquipmentFound' | translate }}</p>
  </mat-card>
}
